
// import axios from 'axios'

const state = {
  ListaBosch: {},
  ListaPulsar: {},
  ListaSzafy: {},
  ListaAkumulatory: {},
  ListaMaterialy: {},
  ListaSelected: {
    'listwaZ': [],
    'listwaD': [],
    'panelS': [],
    'panelW': [],
    'zasilacz_dsos24_pra': [],
    'obudowa_dsos24': [],
    'obudowa_plytki': [],
    'kolka': [],
    'zaslepka': [],
    'polka': []
  }
}

const getters = {
  ListaBosch: state => state.ListaBosch,
  ListaPulsar: state => state.ListaPulsar,
  ListaSzafy: state => state.ListaSzafy,
  ListaAkumulatory: state => state.ListaAkumulatory,
  ListaMaterialy: state => state.ListaMaterialy,
  ListaSelected: state => state.ListaSelected
}

const mutations = {
  SET_LIST_BOSCH (state, payload) {
    state.ListaBosch = payload
  },
  SET_LIST_PULSAR (state, payload) {
    state.ListaPulsar = payload
  },
  SET_LIST_SZAFY (state, payload) {
    state.ListaSzafy = payload
  },
  SET_LIST_AKUMULATORY (state, payload) {
    state.ListaAkumulatory = payload
  },
  SET_LIST_MATERIALY (state, payload) {
    state.ListaMaterialy = payload
  },
  SET_LIST_SELECTED (state, payload) {
    state.ListaSelected[payload.key] = payload.value
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js